export function cepWithSeparator(cep: string): string {
  if (!cep) return '-';

  if (cep?.includes('-')) return cep;
  const first = cep?.substring(0, 5);
  const second = cep?.substring(5);
  return `${first}-${second}`;
}
